import { render, staticRenderFns } from "./PappersForm.vue?vue&type=template&id=29c91548&scoped=true"
import script from "./PappersForm.vue?vue&type=script&lang=js"
export * from "./PappersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c91548",
  null
  
)

export default component.exports